export default __webpack_public_path__ + "static/media/gallery15.c2aa7c0f.jpg";